import {
  ActionDotsIcons,
  DeleteIcon,
  EditIcon,
} from "../../../assets/icons/iconsProvider";
import { Button, ClickableTooltip, TooltipWrapper } from "../../components";
import { buttonNameConstants, buttonTypeConstants } from "../../../constants";
const getItemOrganizationActionColumn = ({
  handleEditClick,
  tooltipRef,
  handleDeleteClick,
  editType,
  params,
}) => {
  return (
    <div
      onMouseLeave={() => {
        tooltipRef.current?.close();
      }}
    >
      <TooltipWrapper>
        <ClickableTooltip
          anchorSelect={`#tool${editType}${params.data.id}`}
          openOnClick={true}
          tooltipRef={tooltipRef}
          offset={-10}
        >
          <Button
            className="w-100"
            IconImage={EditIcon}
            label={buttonNameConstants.EDIT}
            handleClick={() => handleEditClick(editType, params)}
            buttonType={buttonTypeConstants.ACTION_BUTTON}
          />
          <Button
            className="w-100"
            IconImage={DeleteIcon}
            label={buttonNameConstants.DELETE}
            handleClick={() => handleDeleteClick(editType, params)}
            buttonType={buttonTypeConstants.ACTION_BUTTON}
          />
        </ClickableTooltip>
      </TooltipWrapper>
      <button
        id={`tool${editType}${params.data.id}`}
        className="action-Button-Wrapper"
        onClick={() => {
          tooltipRef.current?.isOpen
            ? tooltipRef.current?.close()
            : tooltipRef.current?.open({
                anchorSelect: `#tool${editType}${params.data.id}`,
              });
        }}
      >
        <ActionDotsIcons className="cursor-pointer" />
      </button>
    </div>
  );
};
export { getItemOrganizationActionColumn };
